import React, { useState } from "react";
import "./Feedback.css";
import b1 from "./REVIEWS/book-review/B1.jpg";

import b2 from "./REVIEWS/book-review/B2.jpg";
import b3 from "./REVIEWS/book-review/B3.jpg";
import b4 from "./REVIEWS/book-review/B4.jpg";
import b5 from "./REVIEWS/book-review/B5.jpg";
import b6 from "./REVIEWS/book-review/B6.jpg";
import b7 from "./REVIEWS/book-review/B7.jpg";
import b8 from "./REVIEWS/book-review/B8.jpg";
import b9 from "./REVIEWS/book-review/B9.jpg";
import b10 from "./REVIEWS/book-review/B10.jpg";
import b11 from "./REVIEWS/book-review/B11.jpg";
import b12 from "./REVIEWS/book-review/B12.jpg";
import b13 from "./REVIEWS/book-review/B13.jpg";
import b14 from "./REVIEWS/book-review/B14.jpg";
import b15 from "./REVIEWS/book-review/B15.jpg";
import b16 from "./REVIEWS/book-review/B16.jpg";
import b17 from "./REVIEWS/book-review/B17.jpg";
import b18 from "./REVIEWS/book-review/B18.jpg";
import b19 from "./REVIEWS/book-review/B19.jpg";
import b20 from "./REVIEWS/book-review/B20.jpg";
import b21 from "./REVIEWS/book-review/B21.jpg";
import b22 from "./REVIEWS/book-review/B22.jpg";
import b23 from "./REVIEWS/book-review/B23.jpg";
import b24 from "./REVIEWS/book-review/B24.jpg";






import c1 from "./REVIEWS/course-review/C1.jpg";
import c2 from "./REVIEWS/course-review/C2.jpg";
import c3 from "./REVIEWS/course-review/C3.jpg";
import c4 from "./REVIEWS/course-review/C4.jpg";
import c5 from "./REVIEWS/course-review/C5.jpg";
import c6 from "./REVIEWS/course-review/C6.jpg";
import c7 from "./REVIEWS/course-review/C7.jpg";
import c8 from "./REVIEWS/course-review/C8.jpg";
import c9 from "./REVIEWS/course-review/C9.jpg";
import c10 from "./REVIEWS/course-review/C10.jpg";
import c11 from "./REVIEWS/course-review/C11.jpg";
import c12 from "./REVIEWS/course-review/C12.jpg";

import feedbackPic from "./REVIEWS/feedback.png";

import StarIcon from "@mui/icons-material/Star";
import ChangeHistoryIcon from "@mui/icons-material/ChangeHistory";
import ChangeHistoryTwoToneIcon from "@mui/icons-material/ChangeHistoryTwoTone";

import ArrowForwardIosIcon from "@mui/icons-material/ArrowForwardIos";
import ArrowBackIosIcon from "@mui/icons-material/ArrowBackIos";

function Feedback() {
  const [bookComment, setBookComment] = useState(0);
  const [courseComment, setCourseComment] = useState(0);
  const courseComments  = [b1, b2, b3, b4, b5, b6, b7, b8,b9, b10, b11, b12, b13, b14, b15, b16, b17,b18,b19,b20,b21,b22,b23,b24];
  const bookComments = [c1, c2, c3, c4, c5, c6, c7, c8, c9,c10,c11,c12];

  const handleBookPrev = () => {
    if (bookComment > 0) {
      setBookComment(bookComment - 1);
    } else {
      setBookComment(bookComments.length - 1);
    }
  };

  const handleBookNext = () => {
    if (bookComment < bookComments.length - 1) {
      setBookComment(bookComment + 1);
    } else {
      setBookComment(0);
    }
  };

  const handleCoursePrev = () => {
    if (courseComment > 0) {
      setCourseComment(courseComment - 1);
    } else {
      setCourseComment(courseComments.length - 1);
    }
  };

  const handleCourseNext = () => {
    if (courseComment < courseComments.length - 1) {
      setCourseComment(courseComment + 1);
    } else {
      setCourseComment(0);
    }
  };

  return (
    <div className="feedback" id="feedback">
      {/* <img src={feedbackPic} alt="" className="feedbackImg" /> */}
      <div className="feedbackTitle">Students' feedback</div>
      <div className="book__course">
        <div className="book__container">
          <h2>About The Course</h2>
          <div className="feedbackBook">
            <ArrowBackIosIcon
              className="backArrow"
              onClick={() => handleBookPrev()}
            />

            <img src={bookComments[bookComment]} alt="" />

            <ArrowForwardIosIcon
              className="nextArrow"
              onClick={() => handleBookNext()}
            />
          </div>
        </div>
        <div className="course__container">
          <h2>About The Book</h2>
          <div className="feedbackCourse">
            <ArrowBackIosIcon
              className="backArrow"
              onClick={() => handleCoursePrev()}
            />

            <img src={courseComments[courseComment]} alt="" />

            <ArrowForwardIosIcon
              className="nextArrow"
              onClick={() => handleCourseNext()}
            />
          </div>
        </div>
      </div>
      <iframe
        className="feedback__video"
        src="https://www.youtube.com/embed/zr24DDbd76A?si=tSds6AAaLvlHICUJ"
        title="YouTube video player"
        frameborder="0"
        allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
        referrerpolicy="strict-origin-when-cross-origin"
        allowfullscreen
      ></iframe>
    </div>
  );
}

export default Feedback;
